const CommonInputFiled = ({
  placeholder,
  value,
  onChange,
  className = "",
  type = "text",
  ...rest
}) => {
  if (type === "textarea") {
    return (
      <textarea
        className={`border rounded px-3 py-2 outline-none focus:ring-2 focus:ring-blue-300 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...rest}
      />
    );
  }

  return (
    <input
      type={type}
      className={`border rounded px-3 py-2 outline-none focus:ring-2 focus:ring-blue-300 ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
};

export default CommonInputFiled;
